/**
 * @generated SignedSource<<2863dd1d4f352eec2d210c9eb01709c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type deleteDrawingSetAnnotationMutation$variables = {
  id: string;
};
export type deleteDrawingSetAnnotationMutation$data = {
  readonly deleteDrawingSetAnnotation: {
    readonly " $fragmentSpreads": FragmentRefs<"drawingSetAnnotationFragment">;
  } | null | undefined;
};
export type deleteDrawingSetAnnotationMutation = {
  response: deleteDrawingSetAnnotationMutation$data;
  variables: deleteDrawingSetAnnotationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteDrawingSetAnnotationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSetAnnotation",
        "kind": "LinkedField",
        "name": "deleteDrawingSetAnnotation",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "drawingSetAnnotationFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteDrawingSetAnnotationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSetAnnotation",
        "kind": "LinkedField",
        "name": "deleteDrawingSetAnnotation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "drawingSetId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "drawingSheetId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "xfdf",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a55c67fb93d93562cba0570bf5c0cab4",
    "id": null,
    "metadata": {},
    "name": "deleteDrawingSetAnnotationMutation",
    "operationKind": "mutation",
    "text": "mutation deleteDrawingSetAnnotationMutation(\n  $id: ID!\n) {\n  deleteDrawingSetAnnotation(id: $id) {\n    ...drawingSetAnnotationFragment\n    id\n  }\n}\n\nfragment drawingSetAnnotationFragment on DrawingSetAnnotation {\n  id\n  createdAt\n  updatedAt\n  createdById\n  drawingSetId\n  drawingSheetId\n  type\n  xfdf\n}\n"
  }
};
})();

(node as any).hash = "9d44660bf721f9e275dcc707d4de6050";

export default node;
